<ng-container *ngIf="header ; else defaultHeader">
<h2 mat-dialog-title >
    <app-hint-icon *ngIf="tooltip" hint="{{ tooltip }}"></app-hint-icon>
    {{ header }}</h2>
    <p style="white-space: pre-line">{{infoText}}</p>
    <mat-form-field class="select-search">
        <mat-label>Bieter</mat-label>
        <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="NewEventForm.controls.Customer.setValue(null);$event.stopPropagation();" *ngIf="!NewEventForm.controls.Customer.disabled"></fa-icon>
        <app-select-search-paged-options
            #pagedSelect
            [formControl]="NewEventForm.controls.Customer"
            [Options]="customerSearch.customerOptions$ | async"
            [isLoading]="this.customerSearch.loading$ | async"
            [CompareOptions]="customerCompareOptions"
            (searchChange)="customerserverSearch($event)"
            (opened)="customerserverSearch('')"
        >

            <mat-paginator
                option-list-footer
                #paginator
                [pageSize]="50"
                [length]="(this.customerSearch.customerPaging.pageCount$ | async) * 50"
                [pageIndex]="this.customerSearch.customerPaging.pageIndex$ | async"
                (page)="customerpageChange?.($event)"
            >
            </mat-paginator>
        </app-select-search-paged-options>
    </mat-form-field>
    </ng-container>
<ng-template  #defaultHeader>
    <h2 mat-dialog-title>{{ this.customerLable }} auswählen</h2>
    <mat-form-field class="select-search">
        <mat-label>{{this.customerLable}}</mat-label>
        <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="NewEventForm.controls.Customer.setValue(null);$event.stopPropagation();" *ngIf="!NewEventForm.controls.Customer.disabled"></fa-icon>
        <app-select-search-paged-options
            #pagedSelect
            [formControl]="NewEventForm.controls.Customer"
            [Options]="customerSearch.customerOptions$ | async"
            [isLoading]="this.customerSearch.loading$ | async"
            [CompareOptions]="customerCompareOptions"
            (searchChange)="customerserverSearch($event)"
            (opened)="customerserverSearch('')"
        >

            <mat-paginator
                option-list-footer
                #paginator
                [pageSize]="50"
                [length]="(this.customerSearch.customerPaging.pageCount$ | async) * 50"
                [pageIndex]="this.customerSearch.customerPaging.pageIndex$ | async"
                (page)="customerpageChange?.($event)"
            >
            </mat-paginator>
        </app-select-search-paged-options>
    </mat-form-field>
</ng-template>

<mat-checkbox *ngIf="showCheckbox"
    color="primary"
    [(ngModel)]="selectedFillEmptyValuesWithMtS"
>
    Leere Preise und Beschreibungen aus Stammdaten befüllen
</mat-checkbox>
<mat-dialog-actions class="buttons" style="min-width: 30vw">
    <button app-button Color="cancel" [mat-dialog-close]="{ Confirmed: false }">Abbrechen</button>

    <button app-round-button Color="red" *ngIf="showDeleteButton" (click)="removeSupplier()" [matTooltip]="'Bieter entfernen'">
        <fa-icon icon="trash"></fa-icon>
    </button>
    <button app-button Color="green" [mat-dialog-close]="{ Confirmed: true, SupplierId: this.selectedSupplierId, SelectedFillEmptyValuesWithMtS: this.selectedFillEmptyValuesWithMtS }">Auswählen</button>
</mat-dialog-actions>
